import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetInventoryAPiService from './AssetInventoryAPiService';
import { setAllAssessments, setAssessmentActivateSuccess, setAssessmentById  } from 'Store/AssetInventory/Assessments/AssessmentAction';
import { ACTIVATE_ASSESSMENT, GET_ALL_ASSESSMENTS, GET_ASSESSMENT_BY_ID } from 'Store/AssetInventory/Assessments/AssessmentTypes';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';


function* getAllAssessments(): any {
    try {
        yield put(globalLoaderText("Fetching Assessments...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/allassessment`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAllAssessments(response))
        } else {
            yield put(setAllAssessments([]))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* getAssessmentById(data: any): any {
    try {
        yield put(globalLoaderText("Fetching Assessment...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/allassessment/${data?.id}`,
            apiMethod :  apiMethod.GET,
            payload : null
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAssessmentById(response))
        } else {
            yield put(setAssessmentById({}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}



function* activateAssessment(data: any): any {
    try {
        yield put(globalLoaderText("Activating Assessment...."));
        let payloadData : IPayload = {
            apiType : apiType.AssetManagement,
            endpoint : `inventoryadmin/activeassessment`,
            apiMethod :  apiMethod.POST,
            payload : data.assessment
        }
        const response = yield call(
            AssetInventoryAPiService.post,
            API_URL.PostWebApp, payloadData
            );

        if (response) {
            yield put(globalLoaderText(""));
            yield put(setAssessmentActivateSuccess('success'))       
         } else {
            yield put(setAssessmentActivateSuccess('failed'))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
    }
}

function* watchGetAllAssements() {
    yield takeEvery(GET_ALL_ASSESSMENTS, getAllAssessments)
    yield takeEvery(ACTIVATE_ASSESSMENT, activateAssessment)
    yield takeEvery(GET_ASSESSMENT_BY_ID, getAssessmentById)
}

export default function* combinedSaga() {
    yield all([
        watchGetAllAssements()
    ])
}